import { useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { fetchWrapper } from '../../helpers';
import { toast } from 'react-toastify';

const RedisSyc = () => {
	const [loading, setLoading] = useState(false);

	const handleSync = async () => {
		setLoading(true);
		try {
			const url = `${process.env.REACT_APP_API_URL}/redis/sync`;
			await fetchWrapper.post(url, {});
			toast('Redis sync completed successfully', { type: 'success' });
		} catch (error) {
			toast('Redis sync failed', { type: 'error' });
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="setting_detail_section">
			<Box mb="20px">
				<h2 className="main_heading">Redis Sync</h2>
			</Box>
			<Button
				py="10px"
				px="25px"
				color="#fff"
				bg="#2563eb"
				fontSize="14px"
				fontWeight="500"
				fontFamily="'Open Sans', sans-serif"
				isLoading={loading}
				onClick={handleSync}
			>
				Sync Redis
			</Button>
		</div>
	);
};

export default RedisSyc;
